module.exports = __webpack_public_path__ + "static/open_fct3-f98357ee43a0461bc3418d522894d14f.jpg";